export default "__VITE_ASSET__BFV$dBVY__"